module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-bg-738016ce.png";